function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys } from "vue";
var _hoisted_1 = {
  id: "pum-root"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  "class": "tw-p-0"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  key: 0,
  "class": "tw-text-10 tw-text-white tw-bg-w-primary tw-inline-flex tw-items-center tw-justify-center tw-rounded tw-w-7 tw-h-5 tw-relative"
};
var _hoisted_7 = {
  key: 1,
  "class": "tw-bg-w-danger/15 tw-size-5 tw-rounded-circle tw-border tw-border-solid tw-border-w-danger tw-p-0 tw-flex tw-items-center tw-justify-center tw-text-w-danger"
};
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = {
  key: 1,
  "class": "tw-hidden sm:tw-block tw-p-0 tw-m-0"
};
var _hoisted_10 = {
  "class": "tw-flex tw-w-full tw-items-center tw-justify-end tw-flex-nowrap"
};
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = ["innerHTML"];
import { computed, ref, watch } from "vue";
import { setActionAndRedirect } from "@vueEntry/composables/useUserAction";
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
import { ProfileIcon } from "@vueEntry/SvgIcons/ProfileIcon";
import { HeartIcon } from "@vueEntry/SvgIcons/HeartIcon";
import { RequestIcon } from "@vueEntry/SvgIcons/RequestIcon";
import { BellIcon } from "@vueEntry/SvgIcons/BellIcon";
import { ValuationIcon } from "@vueEntry/SvgIcons/ValuationIcon";
import { ListingsIcon } from "@vueEntry/SvgIcons/ListingsIcon";
import { LogoutIcon } from "@vueEntry/SvgIcons/LogoutIcon";
import SelectItem from "@vueEntry/UIKitComponents/BaseSelect/SelectItem.vue";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
import { useLoggedUserStore } from "@store/LoggedUserStore";
import { useModalStore } from "@store/ModalStore";
import { useBaseStore } from "@store/BaseStore";
import { ArrowIcon } from "@vueEntry/SvgIcons/ArrowIcon";
import { useKeyboardController } from "@wkComposables/useKeyboardController";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { Modals } from "@customTypes/Modals";
export default /*#__PURE__*/_defineComponent({
  __name: 'PublicUserMenu',
  props: {
    privateUrl: {},
    headerWhite: {
      type: Boolean,
      "default": false
    },
    menuItems: {},
    isInsight: {
      type: Boolean,
      "default": false
    },
    isTrend: {
      type: Boolean,
      "default": false
    },
    labels: {},
    wikicasaProLogin: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["logout"],
  setup: function setup(__props, _ref) {
    var _this = this;
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var openDropdown = ref(false);
    watch(openDropdown, function (cur) {
      if (!cur) activeIdx.value = -1;
    });
    var _useKeyboardControlle = useKeyboardController({
        optionsLength: 7,
        isDropdownOpen: openDropdown
      }),
      activeIdx = _useKeyboardControlle.activeIdx;
    var publicUserMenuStore = usePublicUserMenuStore();
    var loggedUserStore = useLoggedUserStore();
    var modalStore = useModalStore();
    var baseStore = useBaseStore();
    var _useCommonVars = useCommonVars(),
      baseURL = _useCommonVars.baseURL;
    var welcomeBackLabel = computed(function () {
      return "".concat(props.menuItems.user.label, " ").concat(publicUserMenuStore.name);
    });
    var fullPrivateUrl = computed(function () {
      return "".concat(baseURL.value, "/").concat(props.privateUrl);
    });
    //Need them because at the time of the creation of the component the store is not yet "ready" so the counter result to be undefined
    var favoritesCounter = computed(function () {
      return publicUserMenuStore.favoritesCounter;
    });
    var requestsCounter = computed(function () {
      return publicUserMenuStore.requestsCounter;
    });
    var savedSearchesCounter = computed(function () {
      return publicUserMenuStore.savedSearchesCounter;
    });
    var menuItemsToSelect = ref([{
      iconComponent: ProfileIcon,
      itemLabel: props.menuItems.profile.label,
      itemUrl: props.menuItems.profile.url,
      mailConfirmedIcon: publicUserMenuStore.mailConfirmed,
      isLink: true
    }, {
      iconComponent: HeartIcon,
      itemLabel: props.menuItems.favorites.label,
      itemUrl: props.menuItems.favorites.url,
      itemCounter: favoritesCounter,
      isLink: true
    }, {
      iconComponent: RequestIcon,
      itemLabel: props.menuItems.requests.label,
      itemUrl: props.menuItems.requests.url,
      itemCounter: requestsCounter
    }, {
      iconComponent: BellIcon,
      itemLabel: props.menuItems.savedSearches.label,
      itemUrl: props.menuItems.savedSearches.url,
      itemCounter: savedSearchesCounter
    }, {
      iconComponent: ValuationIcon,
      itemLabel: props.menuItems.valuation.label,
      itemUrl: props.menuItems.valuation.url
    }, {
      iconComponent: ListingsIcon,
      itemLabel: props.menuItems.listings.label,
      itemUrl: props.menuItems.listings.url
    }]);
    var openModalOrRedirectPro = function openModalOrRedirectPro(login) {
      props.wikicasaProLogin ? window.open("".concat(baseURL.value, "/pro/login")) : login ? modalStore.setShowModal(Modals.loginModal) : modalStore.setShowModal(Modals.signInModal);
    };
    var logout = function logout() {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return baseStore.logout();
            case 2:
              setActionAndRedirect();
              emits("logout");
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(publicUserMenuStore).name && _unref(loggedUserStore).isUserLogged ? (_openBlock(), _createBlock(BaseDropDown, {
        key: 0,
        id: "pum-dropdown",
        "data-cy": "pum-dropdown",
        "dropdown-classes": "tw-z-[1042] tw-shadow !tw-rounded-xs tw-mt-10px !tw-max-h-fit !tw-min-w-[200px] tw-right-0",
        "open-dropdown": openDropdown.value,
        "dropdown-element": "ul",
        "onUpdate:dropdownState": _cache[2] || (_cache[2] = function (v) {
          return openDropdown.value = v;
        })
      }, {
        btn_slot: _withCtx(function (_ref2) {
          var toggleDropdown = _ref2.toggleDropdown,
            isOpen = _ref2.isOpen;
          return [_createElementVNode("div", {
            "class": "tw-flex tw-items-center tw-cursor-pointer tw-p-2",
            onClick: _withModifiers(toggleDropdown, ["stop"])
          }, [_createVNode(_unref(ProfileIcon), {
            width: 20,
            height: 20,
            "class": "tw-inline-block tw-mr-10px",
            "stroke-color": _ctx.headerWhite && !_ctx.isInsight ? '#2b5dff' : '#fff'
          }, null, 8 /* PROPS */, ["stroke-color"]), _createElementVNode("button", {
            type: "button",
            "class": _normalizeClass("tw-bg-transparent ".concat(_ctx.headerWhite && !_ctx.isInsight ? 'tw-text-w-primary' : 'tw-text-white header-white', " tw-mr-20px tw-text-16 tw-font-semibold"))
          }, [_createElementVNode("span", {
            innerHTML: welcomeBackLabel.value
          }, null, 8 /* PROPS */, _hoisted_3)], 2 /* CLASS */), _createVNode(_unref(ArrowIcon), {
            "class": _normalizeClass(["tw-transition-transform motion-reduce:tw-transition-none tw-shrink-0", isOpen && 'tw-rotate-180']),
            width: 15,
            height: 15,
            "stroke-color": _ctx.headerWhite && !_ctx.isInsight ? '#2b5dff' : '#fff'
          }, null, 8 /* PROPS */, ["class", "stroke-color"])], 8 /* PROPS */, _hoisted_2)];
        }),
        "default": _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItemsToSelect.value, function (item, idx) {
            return _openBlock(), _createBlock(SelectItem, {
              key: "pum_item_".concat(idx),
              "class": "tw-relative",
              active: _unref(activeIdx) === idx,
              onMouseover: function onMouseover($event) {
                return activeIdx.value = idx;
              }
            }, {
              "default": _withCtx(function () {
                return [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(publicUserMenuStore).mailConfirmed || item.isLink ? 'a' : 'div'), {
                  "class": _normalizeClass(["tw-flex tw-justify-between tw-items-center tw-no-underline tw-py-10px tw-px-20px tw-my-1", [{
                    'tw-text-gray-300': _unref(publicUserMenuStore).mailConfirmed === false && !item.isLink
                  }, {
                    'tw-cursor-pointer': _unref(publicUserMenuStore).mailConfirmed
                  }]]),
                  href: (_unref(publicUserMenuStore).mailConfirmed || item.isLink) && "".concat(fullPrivateUrl.value, "/").concat(item.itemUrl),
                  onClick: _cache[0] || (_cache[0] = _withModifiers(function () {}, ["stop"]))
                }, {
                  "default": _withCtx(function () {
                    return [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent(item.iconComponent), {
                      height: 15,
                      width: 15,
                      "class": "tw-align-middle tw-mr-10px tw-inline-block",
                      "stroke-color": item.isLink || _unref(publicUserMenuStore).mailConfirmed ? '#222' : '#d1d5db'
                    }, null, 8 /* PROPS */, ["stroke-color"])), _createElementVNode("span", {
                      "class": "tw-p-0 tw-capitalize",
                      innerHTML: item.itemLabel
                    }, null, 8 /* PROPS */, _hoisted_5)]), item.itemCounter && item.itemCounter > 0 && _unref(publicUserMenuStore).mailConfirmed ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.itemCounter), 1 /* TEXT */)) : _createCommentVNode("v-if", true), _unref(publicUserMenuStore).mailConfirmed === false && item.itemUrl === props.menuItems.profile.url ? (_openBlock(), _createElementBlock("span", _hoisted_7, "!")) : _createCommentVNode("v-if", true)];
                  }),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "href"]))];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active", "onMouseover"]);
          }), 128 /* KEYED_FRAGMENT */)), _createCommentVNode(" Logout item "), _createVNode(SelectItem, {
            "class": "tw-bg-w-lavender tw-m-0 [&.active]:!tw-bg-[#C5D4FC] hover:!tw-bg-[#C5D4FC]",
            active: _unref(activeIdx) === menuItemsToSelect.value.length,
            onMouseover: _cache[1] || (_cache[1] = function ($event) {
              return activeIdx.value = menuItemsToSelect.value.length;
            }),
            onKeydown: _withKeys(logout, ["enter"])
          }, {
            "default": _withCtx(function () {
              return [_createElementVNode("button", {
                id: "logout-wrapper",
                "data-cy": "pum-logout-btn",
                type: "button",
                "class": "tw-bg-transparent tw-flex tw-items-center tw-py-10px tw-px-20px tw-mt-1 tw-cursor-pointer tw-w-full",
                onClick: _withModifiers(logout, ["stop"])
              }, [_createVNode(_unref(LogoutIcon), {
                height: 15,
                width: 15,
                "class": "tw-align-middle tw-mr-10px tw-inline-block"
              }), _createElementVNode("span", {
                "class": "tw-p-0 tw-text-w-primary",
                innerHTML: _ctx.menuItems.logout.label
              }, null, 8 /* PROPS */, _hoisted_8)])];
            }),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["active"])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["open-dropdown"])) : _unref(loggedUserStore).isUserLogged === false ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
        id: "login-menu-button",
        "class": "tw-cursor-pointer tw-bg-transparent tw-px-15px tw-py-10px tw-text-w-primary tw-font-semibold tw-items-center tw-no-underline",
        onClick: _cache[3] || (_cache[3] = function ($event) {
          return openModalOrRedirectPro(true);
        })
      }, [_createElementVNode("span", {
        "class": _normalizeClass([_ctx.headerWhite ? 'tw-text-w-primary' : 'tw-text-white', {
          'tw-text-white': _ctx.isInsight
        }]),
        innerHTML: _ctx.labels.login
      }, null, 10 /* CLASS, PROPS */, _hoisted_11)]), _createElementVNode("button", {
        id: "register-menu-button",
        "class": _normalizeClass(["tw-cursor-pointer tw-btn tw-btn-sm tw-rounded tw-border tw-border-solid tw-text-w-primary tw-font-semibold tw-flex tw-items-center lg:tw-mg-15px", [{
          'tw-bg-white': _ctx.isInsight
        }, {
          'tw-border-w-primary': _ctx.headerWhite && !_ctx.isTrend && !_ctx.isInsight
        }, {
          'tw-border-white tw-bg-white': !_ctx.headerWhite || _ctx.isTrend
        }]]),
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return openModalOrRedirectPro(false);
        }),
        innerHTML: _ctx.labels.signin
      }, null, 10 /* CLASS, PROPS */, _hoisted_12)])])) : _createCommentVNode("v-if", true)]);
    };
  }
});